import React from 'react';
import { LazyLoadSpinner } from '@framework-controls/core';

import MaintenanceMenus from 'src/components/MaintenanceMenus/containers/MaintenanceMenus';
import AdditionalServices from 'src/components/AdditionalServices/containers/AdditionalServices';
import CustSearch from 'src/components/CustSearch/containers/CustSearch';
import SignUp from 'src/components/SignUp/containers/SignUp';
import Login from 'src/components/Login/containers/Login';
import UserAccountMenu from 'src/components/UserAccountMenu/containers/UserAccountMenu';
import VehSel from 'src/components/VehSel/containers/VehSel';
import ServiceTab from 'src/components/ServiceTab/containers/ServiceTab';
import AddVehicle from 'src/components/AddVehicle/containers/AddVehicle';
import AddSkipServices from 'src/components/AddSkipServices/containers/AddSkipServices';
import QuickTime from 'src/components/QuickTime/containers/QuickTime';
import CalendarSelect from 'src/components/CalendarSelect/containers/CalendarSelect';
import NewCustInfo from 'src/components/NewCustInfo/containers/NewCustInfo';
import Summary from 'src/components/Summary/containers/Summary';
import Confirmation from 'src/components/Confirmation/containers/Confirmation';
import ResetPassword from 'src/components/ResetPassword/containers/ResetPassword';
import PropertyOptions from 'src/components/AddVehicle/DesktopPane/PropertyOptions/containers/PropertyOptions';
import ViewAccount from 'src/components/ViewAccount/containers/ViewAccount';
import ContactDealer from 'src/components/ContactDealer/ContactDealer';
import AddCustVehicle from 'src/components/AddCustVehicle/containers/AddCustVehicle';
import VehLayout from 'src/components/VehLayout/containers/VehLayout';
import UpcomingApptCard from 'src/components/UpcomingApptCard/containers/UpcomingApptCard';
import ChangePassword from 'src/components/ChangePassword/containers/ChangePassword';
import ApptSel from 'src/components/ApptSel/containers/ApptSel';
import CurrentRepair from 'src/components/CurrentRepairCard/containers/CurrentRepairCard';
import OpenRepairSelect from 'src/components/OpenRepairSelect/containers/OpenRepairSelect';
import VehicleCard from 'src/components/VehicleCard/containers/VehicleCard';
import ThankYou from 'src/components/ThankYou/containers/ThankYou';
import LandingPage from 'src/components/LandingPage/containers/LandingPage';
import ServiceDocs from 'src/components/ServiceDocs/containers/ServiceDocs';
import ViewServiceHistory from '../ViewServiceHistory/containers/ViewServiceHistory';
import DiagnoseTree from 'src/components/WriteYourOwn/DesktopView/DesktopDiagnoseModal/DiagnoseTree';
import DiagnoseEnd from 'src/components/WriteYourOwn/DesktopView/DesktopDiagnoseModal/DiagnoseEnd';
import VerifyIdentity from 'src/components/VerifyIdentity/containers/VerifyIdentity';
import OEMCustSearch from 'src/components/OEMCustSearch/containers/OEMCustSearch';
import PickupDelivery from '../PickupDelivery/containers/PickupDelivery';

const ComponentMap = {
    MaintenanceMenus,
    AdditionalServices,
    CustSearch,
    SignUp,
    Login,
    UserAccountMenu,
    VehSel,
    ServiceTab,
    AddVehicle,
    AddSkipServices,
    QuickTime,
    CalendarSelect,
    NewCustInfo,
    Summary,
    Confirmation,
    ResetPassword,
    PropertyOptions,
    ViewAccount,
    ContactDealer,
    AddCustVehicle,
    VehLayout,
    UpcomingApptCard,
    ChangePassword,
    CurrentRepair,
    ApptSel,
    OpenRepairSelect,
    VehicleCard,
    ThankYou,
    LandingPage,
    ServiceDocs,
    ViewServiceHistory,
    DiagnoseTree,
    DiagnoseEnd,
    VerifyIdentity,
    OEMCustSearch,
    PickupDelivery,
};

type ComponentTypes = {
    [K in keyof typeof ComponentMap]: {
        component: K;
    } & React.ComponentProps<(typeof ComponentMap)[K]>;
};

type IProps = ComponentTypes[keyof ComponentTypes];

const RenderComponent = (props: IProps) => {
    const { component, ...componentProps } = props;

    const InnerComponent = ComponentMap[component] as React.ComponentType<typeof componentProps>;

    return <LazyLoadSpinner><InnerComponent {...componentProps} /></LazyLoadSpinner>;
};

export default RenderComponent;